function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "trash-simple",
  transform: "translate(-3 -1)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_429",
  "data-name": "Trac\\xE9 429",
  d: "M29.643,18V35.857a1.786,1.786,0,0,1-1.786,1.786H11.786A1.786,1.786,0,0,1,10,35.857V18",
  transform: "translate(-3.321 -8.857)",
  fill: "none",
  stroke: "#e5137d",
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Ligne_25",
  "data-name": "Ligne 25",
  y2: 10,
  transform: "translate(17 13.786)",
  fill: "none",
  stroke: "#e5137d",
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Ligne_26",
  "data-name": "Ligne 26",
  y2: 10,
  transform: "translate(12 13.786)",
  fill: "none",
  stroke: "#e5137d",
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Ligne_27",
  "data-name": "Ligne 27",
  y2: 10,
  transform: "translate(21 13.786)",
  fill: "none",
  stroke: "#e5137d",
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_430",
  "data-name": "Trac\\xE9 430",
  d: "M22,6.464V2h8.929V6.464",
  transform: "translate(-9.964)",
  fill: "none",
  stroke: "#e5137d",
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Ligne_28",
  "data-name": "Ligne 28",
  x1: 25,
  transform: "translate(4 6.786)",
  fill: "none",
  stroke: "#e5137d",
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  strokeWidth: 2
}));

var SvgTrashSimple = function SvgTrashSimple(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28.786,
    viewBox: "0 0 27 28.786",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrashSimple, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trash-simple.5afd26a3.svg";
export { ForwardRef as ReactComponent };